import { render, staticRenderFns } from "./main_new.vue?vue&type=template&id=49528b9b&scoped=true"
import script from "./main_new.vue?vue&type=script&lang=js"
export * from "./main_new.vue?vue&type=script&lang=js"
import style0 from "./main_new.vue?vue&type=style&index=0&id=49528b9b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49528b9b",
  null
  
)

export default component.exports